module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_LT-82300d5d4324c3bcf9759fcad90b80e8.svg";